const s=(s,t)=>s.slice().sort(t);export{s as default};
